window.PlummeI18n.register('en', {
  "km.driver.add": "Add driver under Payroll",
  "km.driver.addRequired": "Add the person who drove under Payroll before registering the trip. Select their actual role, including when the driver is an owner.",
  "km.driver.chooseRequired": "Select the person who drove before saving the trip.",

  "km.portal.all": "All",
  "km.portal.sent": "Submitted",
  "km.portal.approved": "Approved",
  "km.portal.inPayroll": "Included in payroll",
  "km.portal.rejected": "Rejected",
  "km.portal.draft": "Draft",
  "km.portal.pendingPayroll": "Processed in payroll after employer approval.",
  "err.mileage.recipient": "Select a named recipient with a confirmed reporting role.",
  "km.flow.profile": "Check business settings",
  "km.flow.profileHelp": "Country or legal form is missing from the saved business settings. Check and save the correct legal form under Settings → Business, then return to the trip to post the sole proprietor deduction. You do not need to register the trip again.",
  "km.flow.savePost": "Save and post mileage deduction",
  "km.flow.saveSubmit": "Save and submit travel claim",
  "km.recipient.setup": "Link owner to recipient",
  "km.recipient.person": "Recipient",
  "km.recipient.help": "Select the person receiving the allowance. Register the person under Payroll with their actual role: employee, freelancer or board member. Ownership does not automatically mean employment.",
  "km.recipient.create": "Open Payroll – register or check recipient",
  "km.recipient.confirm": "I confirm that this person is the owner who drove and their reporting role is correctly registered.",
  "km.privateUse.standardConfirmed": "I have confirmed that the standard rules apply. This is not sporadic private use or another special case.",
  "km.privateUse.action": "Process private use of business vehicle",
  "km.privateUse.calculate": "Calculate for review",
  "km.privateUse.transfer": "Add to payroll draft",
  "km.privateUse.post": "Post annual private-use adjustment",
  "km.privateUse.help": "Standard calculation for Norway 2026. Private driving does not create a mileage deduction. Company-car benefits are processed monthly through payroll; proprietor business cars annually. Individual kilometre valuation and partial-year proprietor cases require separate assessment.",
  "km.privateUse.month": "Month (1–12)",
  "km.privateUse.class": "Vehicle class",
  "km.privateUse.passenger": "Passenger car – standard rule",
  "km.privateUse.van": "Class-2 van – standard rule",
  "km.privateUse.price": "Original list price including extras",
  "km.privateUse.firstYear": "Year of first registration",
  "km.privateUse.businessNeed": "I confirm a business need for the class-2 van.",
  "km.privateUse.fullYear": "The car was available privately all year. Annual costs are established.",
  "km.privateUse.monthAvailable": "The car was available privately in the selected month.",
  "km.privateUse.financing": "Owned or leased",
  "km.privateUse.owned": "Owned car",
  "km.privateUse.leased": "Leased car",
  "km.privateUse.costs": "Annual operating costs excluding depreciation and leasing",
  "km.privateUse.leaseCosts": "Annual leasing cost",
  "km.privateUse.evidence": "Reference to vehicle and cost documentation",
  "km.privateUse.result": "Calculated amount for processing",
  "km.privateUse.standard": "Full-year standard benefit",
  "km.privateUse.ceiling": "75% of calculated vehicle costs",
  "km.privateUse.processed": "Processing has been created. Check the voucher or payroll run for its current status. Use the original entry for corrections.",
  "km.privateUse.open": "Open processing",
  "km.privateUse.run": "Payroll draft in benefit month",
  "km.privateUse.chooseRun": "Select payroll draft",
  "km.privateUse.noRun": "First create a payroll draft with payment date in this month under Payroll.",
  "km.privateUse.confirm": "I have reviewed the evidence and amount. This car benefit or private-use adjustment has not already been included elsewhere.",
  "km.privateUse.tripHelp": "Private driving is documented, but any car benefit or private-use adjustment must be processed separately. Use the same monthly or annual assessment for all trips with this vehicle.",
  "km.privateUse.highMileage": "Over 40,000 km documented business driving in this passenger car this year",
  "km.privateUse.logReference": "Reference to qualifying electronic driving log",
  "km.flow.driver": "Driver",
  "km.flow.choose": "Choose driver",
  "km.flow.owner": "Proprietor / owner",
  "km.flow.car": "Car type",
  "km.flow.privateCar": "Private car",
  "km.flow.companyCar": "Business-owned car",
  "km.flow.name": "Owner name",
  "km.flow.policyHelp": "Standard is preselected. Choose the government rate only if agreed with your employer. The higher rate is partly taxable.",
  "km.flow.policy": "Agreed allowance (2026)",
  "km.flow.taxFree": "Standard – tax-free rate, NOK 3.50/km",
  "km.flow.government": "Government rate – NOK 5.30/km (partly taxable)",
  "km.flow.failed": "Could not save the trip. Try again.",
  "km.flow.estimated": "Calculated amount",
  "km.flow.registered": "Registered – not posted",
  "km.flow.sent": "Linked to travel claim",
  "km.flow.assign": "Choose / change driver",
  "km.flow.post": "Post mileage deduction",
  "km.flow.submit": "Submit travel claim",
  "km.flow.viewTravel": "View travel claim",
  "km.flow.viewVoucher": "View voucher",
  "km.flow.review": "Review allowance",
  "km.flow.confirmPrivate": "I confirm this is the proprietor’s business journey in a private car qualifying for kilometre deductions, not a business vehicle. This trip has not been expensed elsewhere.",
  "km.flow.reviewHelp": "If the owner is employed, select them from the employee list and submit a travel claim. For a non-employed owner, the role and reporting must be clarified. This settlement flow is not yet supported. The trip is saved without posting.",
  "km.flow.portalLog": "Mileage log",
  "km.flow.newMileage": "Register journey",
  "km.flow.precision": "Check the route and distance before submitting.",
  "km.flow.kmUnit": "km",
  "err.mileage.year": "Mileage rates require review for this year.",
  "err.mileage.rate": "Invalid mileage rate.",
  "err.mileage.identity": "A trip identifier is required.",
  "err.mileage.locked": "This trip is already posted or linked to a travel claim. Open that document to continue.",
  "err.mileage.country": "This mileage workflow currently supports Norway only.",
  "err.mileage.legacy": "Legacy trips require review before deletion.",
  "err.mileage.fields": "Complete date, route, purpose and distance.",
  "err.mileage.employee": "Choose an active employee.",
  "err.mileage.missing": "Trip not found.",
  "err.mileage.proprietor": "Only the proprietor’s eligible private-car business trip can be posted here.",
  "err.mileage.confirmation": "Confirm that the car qualifies for kilometre deductions.",
  "err.mileage.threshold": "At 6,000 km or more, review private-car versus business-car treatment before posting.",
  "err.mileage.submission": "Choose an employee and a private-car business trip before submitting.",
  "err.mileage.conflict": "Travel identifier already exists.",
  "err.mileage.operation": "Unsupported mileage action.",
  "err.mileage.scoped": "Use the mileage workflow to change this trip.",
  "err.mileage.journal": "This trip already has a journal entry. Open the voucher instead.",
  "km.flow.rateHelp": "For 2026 the proprietor deduction and tax-free base rate are NOK 3.50/km. Employees may receive the agreed government rate of NOK 5.30/km; the excess is taxable.",
  "km.flow.amountHelp": "The calculated amount is not necessarily posted or tax-free. Choose the driver and use the trip action to continue.",
  "km.flow.saveHelp": "Saves the documentation without posting. Open the trip to choose a driver, post a proprietor deduction or submit a travel claim.",
  "km.flow.pageHelp": "Register journeys for the proprietor or employees. Private cars and business-owned vehicles have different treatment. Registration alone creates no accounting entry.",
  "km.flow.rejected": "Rejected – view travel claim",
  "km.flow.notLoaded": "The voucher has not loaded yet. Please wait and try again.",
  "km.vehicles.optional": "Optional. Select a registered vehicle for statistics per car.",
  "km.vehicles.title": "Vehicles",
  "km.vehicles.add": "Register vehicle",
  "km.vehicles.registration": "Registration number",
  "km.vehicles.name": "Name (optional)",
  "km.vehicles.total": "Total",
  "km.vehicles.help": "Kilometres in {year}. This register is for mileage only, not fixed assets.",
  "km.vehicles.unassigned": "No vehicle",
  "km.vehicles.archived": "Archived",
  "km.vehicles.remove": "Delete / archive",
  "km.vehicles.removeHelp": "Unused vehicles are deleted. Vehicles used on trips are archived and retained in history.",
  "km.vehicles.history": "Changes apply to new trips. Existing trips retain their registration and ownership.",
  "km.vehicles.confirm": "I confirm that this is business travel with a private car and has not already been submitted for reimbursement.",
  "err.mileage.vehicleInvalid": "Enter a valid registration number and ownership.",
  "err.mileage.vehicleDuplicate": "This registration number already exists, including archived vehicles.",
  "err.mileage.vehicleMissing": "Choose an active vehicle."
});
